import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AdminPanel.css';
import Navbar from './Navbar';
const GeneralSettings = () => {
    const [settings, setSettings] = useState({
        name: '',
        tgLink: '',
        tgId: '',
        botToken: '',
        alertLink: ''
    });
    const [loading, setLoading] = useState(true);
    const [authChecked, setAuthChecked] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const navigate = useNavigate();

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };

    const checkAuth = async () => {
        try {
            const token = getCookie('offerAdminAuth');
            if (!token) {
                navigate('/adminBT/login');
                return false;
            }

            const res = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'checkAuth',
                authToken: token
            });

            if (!res.data.status) {
                navigate('/adminBT/login');
                return false;
            }
            return true;
        } catch (error) {
            navigate('/adminBT/login');
            return false;
        }
    };

    const fetchSettings = async () => {
        try {
            const token = getCookie('offerAdminAuth');
            const response = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'getGeneralSettings',
                authToken: token
            });

            if (response.data.status) {
                setSettings(response.data.data);
            } else {
                console.error('Failed to fetch general settings:', response.data.message);
            }
        } catch (error) {
            console.error("Error fetching general settings:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const verifyAuth = async () => {
            const isAuthenticated = await checkAuth();
            setAuthChecked(isAuthenticated);
            if (isAuthenticated) {
                await fetchSettings();
            }
        };
        verifyAuth();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSettings(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleUpdate = async () => {
        setIsUpdating(true);
        try {
            const token = getCookie('offerAdminAuth');
            const response = await axios.post('https://offers.cashbolt.in.net/server/', {
                action: 'updateGeneralSettings',
                authToken: token,
                ...settings
            });

            if (response.data.status) {
                alert('Settings updated successfully!');
            } else {
                console.error('Failed to update settings:', response.data.message);
                alert('Failed to update settings: ' + response.data.message);
            }
        } catch (error) {
            console.error("Error updating settings:", error);
            alert('Error updating settings');
        } finally {
            setIsUpdating(false);
        }
    };

    if (!authChecked || loading) {
        return (
            <div className="admin-loading">
                <div className="loading-spinner"></div>
            </div>
        );
    }

    return (
        <div className="admin-container">
            <Navbar/>
            <div className="settings-card">
                <h2>General Settings</h2>
                
                <div className="form-grid">
                    <div className="input-section">
                        <div className="form-group">
                            <label>Application Name</label>
                            <input
                                type="text"
                                name="name"
                                value={settings.name}
                                onChange={handleInputChange}
                                placeholder="Enter application name"
                            />
                        </div>

                        <div className="form-group">
                            <label>Telegram Group Link</label>
                            <input
                                type="text"
                                name="tgLink"
                                value={settings.tgLink}
                                onChange={handleInputChange}
                                placeholder="https://t.me/yourgroup"
                            />
                        </div>

                        <div className="form-group">
                            <label>Telegram Chat ID</label>
                            <input
                                type="text"
                                name="tgId"
                                value={settings.tgId}
                                onChange={handleInputChange}
                                placeholder="@yourchatid"
                            />
                        </div>
                    </div>

                    <div className="input-section">
                        <div className="form-group">
                            <label>Telegram Bot Token</label>
                            <input
                                type="text"
                                name="botToken"
                                value={settings.botToken}
                                onChange={handleInputChange}
                                placeholder="123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11"
                            />
                        </div>

                        <div className="form-group">
                            <label>Alert Link</label>
                            <input
                                type="text"
                                name="alertLink"
                                value={settings.alertLink}
                                onChange={handleInputChange}
                                placeholder="https://api.alertservice.com/trigger"
                            />
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <button 
                        type="button" 
                        className="submit-btn"
                        onClick={handleUpdate}
                        disabled={isUpdating}
                    >
                        {isUpdating ? 'Updating...' : 'Update Settings'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GeneralSettings;